export const MISSING_SCOPE = 'MISSING_SCOPE';
export const RESTRICTED_BY_SOURCE_APP = 'RESTRICTED_BY_SOURCE_APP';